<template>
  <DBox
    :id="'cmp-settings-booking-statuses'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add_booking_status')}`"
    @add_click="onAddBookingStatus"
  >
    <NTable
      id="settings-label-statuses-table"
      class="h1"
      :config="tableConfig"
      :headers="headers"
      :items="statuses"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('booking_status_name')">
            <span
              class="txtov"
              :class="{
                'ut-fb ut-link': item.label_status_id != '',
              }"
              :title="item['booking_status_name']"
              @click="(e) => onStatusClick(item)"
            >
              {{ item["booking_status_name"] }}
            </span>
          </td>
          <td v-bind="tdcon('booking_status_colour')">
            <ColorPicker
              :value="`#${item.booking_status_colour}`"
              @input="(val) => onColorPickerChange(item, val)"
            />
          </td>
          <td v-bind="tdcon('options')">
            <img
              src="static/icons/delete.svg"
              @click="(e) => onDeleteStatus(item)"
              class="dt-icon v5 s1"
              :alt="$t('delete_status')"
              :title="$t('delete_status')"
            />
          </td>
        </tr>
      </template>
    </NTable>
    <!-- <div class="dt-list v2">
      <div
        class="dt-list-item"
        v-for="status of statuses"
        :key="status.booking_status_id"
      >
        <div class="dt-list-item--body">
          <div class="dt-list-item--text" @click="e => onStatusClick(status)">
            {{ status.booking_status_name }}
          </div>
          <div class="dt-list-item--icon">
            <ColorPicker
              :value="`#${status.booking_status_colour}`"
              @input="val => onColorPickerChange(status, val)"
            />
          </div>
          <div class="dt-list-item--icon">
            <div class="dt-icon-container">
              <img
                src="static/icons/delete.svg"
                @click="e => onDeleteStatus(status)"
                class="dt-icon v5 s1"
                alt="Delete Status"
                title="Delete Status"
              />
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </DBox>
</template>
<script>
import DBox from "@dtplugins/dbox/dbox";
import ColorPicker from "@plugins/color-picker/color-picker";
import { openModalRoute } from "../../../../dt-plugins/modal/modal.mixin";
import { createTableHeader, createNTableConfig } from "../../../../plugins/datatable";
export default {
  components: {
    DBox,
    ColorPicker
  },
  props: {
    statuses: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
    tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
        showHeader: false,
        rowHeight: 32,
      })
    
    };
  },
  computed: {
    headers() {
      return [
        createTableHeader("booking_status_name"),
        createTableHeader("booking_status_colour", { text: false, mw: 30 }),
        createTableHeader("options", { text: false, mw: 30 }),
      ];
    },
  },
  methods: {
    onAddBookingStatus: function() {
      this.$emit("added", true);
    },
    onChooseColor: function() {},
    onDeleteStatus: function(status) {
      this.$emit("deleted", status.booking_status_id);
    },
    onColorPickerChange: function({ booking_status_id }, value) {
      this.$emit("color_changed", {
        booking_status_id,
        booking_status_colour: value.hex.slice(1)
      });
    },
    onStatusClick: function({ booking_status_id }) {
      openModalRoute(this, "edit_status", {
        booking_status_id
      });
    }
    //MARK: Methods
  }
};
</script>

<style lang="scss">
.cmp-settings-booking-statuses {
  .dt-list-item--text {
    flex: 2;
    font-weight: 600;
    cursor: pointer;
  }
  .dt-list-item--icon:nth-child(2) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .color-picker-value {
    }
  }
}
</style>
